import { Blanket, BlanketImage, BlanketInfo } from "@/components/core/blanket.tsx";
import { Button } from "@/components/core/buttons/button";
import { useModal } from "@/components/core/modals/use-modal.ts";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import ReportStaticModal from "@/components/report-statistic-modal";
import SampleModal from "@/components/sample-modal";
import { IconMoodLookDown, IconPlus } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_backoffice/report-statistic")({
	component: RouteComponent,
});

function RouteComponent() {
	const modal = useModal();
	return (
		<Content pageName="Report Statistic">
			{/*<Header title="Report Statistic" />*/}
			<div className="flex flex-col w-full p-4">
				<Blanket width="sm">
					<BlanketImage icon={<IconMoodLookDown size={30} stroke={1.5} />} />
					<BlanketInfo
						title="No Data"
						message="No available data for for now. Please click generate button."
						action={
							<Button
								onClick={() => {
									modal.openModal({
										title: "Generate Report",
										showHeader: false,
										showFooter: false,
										size: "full",
										component: <ReportStaticModal />,
									});
								}}
							>
								<IconPlus size={18} stroke={2} />
								<span className="font-semibold pr-1">Generate</span>
							</Button>
						}
					/>
				</Blanket>
			</div>
		</Content>
	);
}
